import { Icon } from '@iconify/react';
import React from 'react';

const Testimonial = ({ img, name, designation, subTitle, varient }) => {
  const initials = name.split(' ')
  return (
    <div className={`st-testimonial st-style1 ${varient} wow fadeInLeft`} data-wow-duration="0.8s" data-wow-delay="0.2s" >
      <div className="st-testimonial-info">
        <div className="st-testimonial-img">
          <div style={{width:90,height:90,borderRadius:90,backgroundColor:'pink',color:"#FFF",fontWeight:'bold',display:"flex",justifyContent:"center",alignSelf:'center',alignItems:'center'}}>
            <h3 style={{color:"white",lineHeight:10}}>{(initials[0][0]).toUpperCase()+""+initials[1][0]}</h3>
          </div>
        </div>
        <div className="st-testimonial-meta">
          <h4 className="st-testimonial-name">{name}</h4>
          <div className="st-testimonial-designation">{}</div>
        </div>
      </div>
      <div className="st-testimonial-text">{subTitle}</div>
      <div className="st-quote">
        <Icon icon="fa-solid:quote-right" />
      </div>
    </div>
  )
}

export default Testimonial;
